import axios from '@/utils/axios';

export type ImpersonationCodeResponse = {
  code: string;
  [key: string]: unknown;
};

export type StartImpersonationPayload = {
  reason?: string;
};

export const startUserImpersonation = async (
  userId: number,
  payload?: StartImpersonationPayload
): Promise<ImpersonationCodeResponse> => {
  const {
    data: { data },
  } = await axios.post<{ data: ImpersonationCodeResponse }>(
    `/admin/impersonate/user/${userId}`,
    payload ?? {}
  );

  return data;
};
